import Toast from 'antd-mobile/es/components/toast';
import { DEFAULT_TIMEOUT } from './network/request';

const DEFAULT_DURATION = 1500;

class ToastUtils {
  private currentToast;

  constructor() {
    Toast.config({
      duration: DEFAULT_TIMEOUT,
      maskClickable: false,
    });
  }

  public loading() {
    this.currentToast = this.show({
      icon: 'loading',
      content: '加载中...',
    });
  }

  public info(tips) {
    this.show({
      content: tips,
      duration: DEFAULT_DURATION,
    });
  }

  public close() {
    this.currentToast ? this.currentToast?.close() : Toast.clear();
    this.currentToast = null;
  }

  private show(params?: any) {
    this.currentToast = Toast.show({
      ...params,
      afterClose: () => {
        params?.close?.();
      },
    });
  }
}

const toast = new ToastUtils();

export default toast;
